<div class="card-expanded-host">
  <app-cards [card]="cardType" [controlsOptions]="controls"></app-cards>
</div>
